import { View, TextInput, TouchableOpacity, Keyboard } from "react-native";
import MaterialIcons from "@expo/vector-icons/MaterialIcons";
import i18n from "../../locales/i18n";

interface QuantityInputProps {
  custumQunatity: string;
  setCustumQuantity: (quantity: string) => void;
  selectedTag: number | null;
  handleIncrementQuantity: () => void;
  handleDecrementQuantity: () => void;
  handelAddProduct: () => void;
}

const QuantityInput: React.FC<QuantityInputProps> = ({
  custumQunatity,
  setCustumQuantity,
  selectedTag,
  handleIncrementQuantity,
  handleDecrementQuantity,
  handelAddProduct,
}) => {
  return (
    <View className="justify-center items-center">
      <View
        className="bg-white rounded-full border-2 border-blue-400"
        style={{
          shadowColor: "#000",
          shadowOffset: {
            width: 0,
            height: 1,
          },
          shadowOpacity: 0.1,
          shadowRadius: 2,
          elevation: 3,
        }}
      >
        <View className="flex-row items-center justify-between px-4 ">
          <TouchableOpacity
            onPress={handleDecrementQuantity}
            disabled={!selectedTag}
            className="p-1"
          >
            <MaterialIcons
              name="keyboard-arrow-down"
              size={20}
              color={selectedTag ? "#3B82F6" : "#9CA3AF"}
            />
          </TouchableOpacity>

          <TextInput
            style={{
              fontSize: 16,
              minWidth: 60,
              textAlign: "center",
              color: "#1F2937",
              fontWeight: "600",
            }}
            onChangeText={(text) => {
              setCustumQuantity(text);
            }}
            keyboardType="decimal-pad"
            autoCapitalize="none"
            placeholder={i18n.t("quantity")}
            placeholderTextColor="#9CA3AF"
            value={custumQunatity.toString()}
            onSubmitEditing={() => {
              if (handelAddProduct) {
                handelAddProduct();
              }
            }}
            returnKeyType="done"
          />

          <TouchableOpacity
            onPress={handleIncrementQuantity}
            disabled={!selectedTag}
            className="p-1"
          >
            <MaterialIcons
              name="keyboard-arrow-up"
              size={20}
              color={selectedTag ? "#3B82F6" : "#9CA3AF"}
            />
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default QuantityInput;
